import { render, staticRenderFns } from "./StartPHQ9.vue?vue&type=template&id=86d29f3c&scoped=true&"
import script from "./StartPHQ9.vue?vue&type=script&lang=js&"
export * from "./StartPHQ9.vue?vue&type=script&lang=js&"
import style0 from "./StartPHQ9.vue?vue&type=style&index=0&id=86d29f3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d29f3c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1532393991/src/playtient-web-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86d29f3c')) {
      api.createRecord('86d29f3c', component.options)
    } else {
      api.reload('86d29f3c', component.options)
    }
    module.hot.accept("./StartPHQ9.vue?vue&type=template&id=86d29f3c&scoped=true&", function () {
      api.rerender('86d29f3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StartPHQ9.vue"
export default component.exports